module.exports = __webpack_public_path__ + "static/media/ico_native_endpoint.c687515b.svg";